/*******************************************************************************
Automatically Add Button Processing State
Triggers the processing state on a button.
*******************************************************************************/

export default function automaticButtonProcessing(e) {

    const $button = $(e.currentTarget);
    const buttonHTML = $button.html();
    const buttonText = $button.clone().find('>*').remove().end().html(); // eslint-disable-line newline-per-chained-call
    const processingText = $button.data('inprogress') || '';

    const newButtonHTML = buttonHTML.replace(buttonText, processingText);

    // Set a data attribute with the original button html
    $button.data('origbuttonhtml', buttonHTML);

    // Set the button HTML
    $button.safehtml(newButtonHTML);

    // Disable the button
    $button.prop('disabled', true);

    // Remove the ripple-effect after 1 sec
    setTimeout(() => {
        $button.find('.ripple-effect').remove();
    }, 1000);
}
